import { render, staticRenderFns } from "./_base-input-text.vue?vue&type=template&id=6c2d00da&"
import script from "./_base-input-text.vue?vue&type=script&lang=js&"
export * from "./_base-input-text.vue?vue&type=script&lang=js&"
import style0 from "./_base-input-text.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
